export default __webpack_public_path__ + "static/anti-aging-og-image-1eef12cd699cfdc88626df07bc8d2541.jpg";